import {
  BlueYonderLocation,
  DropoffLocation,
  HappyReturnsLocation,
  InteractiveMapLocation,
  ShipmentMethodName,
} from "@redotech/redo-model/draft-return/draft-return";
import { DropoffLocationResult } from "@redotech/redo-model/dropoff/dropoff-types";
import { Big } from "big.js";
import { isAHoliday } from "../utils/federal-holidays";

export type ShipmentMethodOption = {
  type: ShipmentMethodName;
  pickupFee?: Big;
  pickupCoveredByMerchant?: boolean;
  nonPickupFee?: Big;
  customerUpchargeFee?: Big;
  orderValue?: Big;
  happyReturnsDetails?: {
    locations: HappyReturnsLocation[];
    zipCode: string;
    retailerId: string;
  };
  inStoreLocations?: InteractiveMapLocation[];
  blueYonderDetails?: {
    locations: BlueYonderLocation[];
    retailerCompanyId: string;
    privacyPolicyText: string;
  };
  returnBearDetails?: {
    locations: DropoffLocation[];
    returnBearCaseId: string;
    returnBearCaseShortId: string;
    returnBearExternalRMAReferenceId?: string | null;
  };
  dropoffs?: DropoffLocationResult[];
};

export const getValidDate = (date: Temporal.PlainDate, days: number) => {
  date = date.add({ days });
  while (!isValidDate(date)) {
    date = date.add({ days: 1 });
  }
  return date;
};

// FedEx does not allow pickups on weekends or holidays
export const isValidDate = (date: Temporal.PlainDate) => {
  return (
    date.dayOfWeek !== 7 && date.dayOfWeek !== 6 && !isFederalHoliday(date)
  );
};

export const textReminderEligible = (
  pickupDate: Temporal.PlainDate | undefined,
) => {
  // We only want to allow users to opt into reminder texts if the pickup is at least 2 days away
  if (!pickupDate) {
    return false;
  }

  const today = Temporal.Now.plainDateISO();
  return today.until(pickupDate).days > 1;
};

export const isFederalHoliday = (date: Temporal.PlainDate) => {
  // Convert Temporal.PlainDate to JavaScript Date
  const jsDate = new Date(date.year, date.month - 1, date.day);
  return isAHoliday(jsDate);
};
